import axios from "axios";
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  GET_USERS,
  AUTHORIZE_TOKEN,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  MESSAGE_ERROR,
  CLEAR_PROFILE,
  CLEAR_NOTIFICATIONS,
  CLEAR_SUBSCRIBERS,
  CLEAR_SUBSCRIPTIONS,
  CLEAR_BLOCKED_USERS,
  CLEAR_GIFTED_SUBSCRIBERS,
  CLEAR_EMAIL,
  DELETE_USER,
  DELETE_USER_ERROR,
  DELETE_USER_ACCOUNT,
  DELETE_USER_ACCOUNT_ERROR,
} from "./types";
import setAuthToken from "../utilities/setAuthToken";

// Load User
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }

  try {
    const res = await axios.get(`/api/profile`);

    dispatch({
      type: USER_LOADED,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
  }
};

// Check for existing usernames
export const getActiveUsers = (textValue) => async (dispatch) => {
  const formData = new FormData();
  formData.append("text", JSON.stringify(textValue));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/owner/users`, formData, config);

    dispatch({
      type: GET_USERS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: MESSAGE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Register Innovator
export const register =
  ({ firstname, lastname, username, jobtitle, email, password, location }) =>
  async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      firstname,
      lastname,
      username,
      jobtitle,
      email,
      password,
      location,
    });

    try {
      const res = await axios.post("/api/innovator/register", body, config);

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });

      dispatch(loadUser());
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        console.error(errors);
      }

      dispatch({
        type: REGISTER_FAIL,
      });
    }
  };

// Register Mentor
export const registerMentor =
  ({ firstname, lastname, username, jobtitle, email, password, location }) =>
  async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      firstname,
      lastname,
      username,
      jobtitle,
      email,
      password,
      location,
    });

    try {
      const res = await axios.post("/api/mentor/register", body, config);

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });

      dispatch(loadUser());
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        console.error(errors);
      }

      dispatch({
        type: REGISTER_FAIL,
      });
    }
  };

// Register Employer
export const registerEmployer =
  ({ companyname, firstname, lastname, username, location, email, password }) =>
  async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({
      companyname,
      firstname,
      lastname,
      username,
      location,
      email,
      password,
    });

    try {
      const res = await axios.post("/api/employer/register", body, config);

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data,
      });

      dispatch(loadUser());
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        console.error(errors);
      }

      dispatch({
        type: REGISTER_FAIL,
      });
    }
  };

// Login User
export const login = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post("/api/innovator", body, config);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.msg,
    });
  }
};

// Authorize Innovator 2FA Token
export const authorizeToken = (token, channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ token, channelid });

  try {
    const res = await axios.post("/api/innovator/verify", body, config);

    dispatch({
      type: AUTHORIZE_TOKEN,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.msg,
    });
  }
};

// Login Mentor
export const loginMentor = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post("/api/mentor", body, config);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.msg,
    });
  }
};

// Authorize Mentor 2FA Token
export const authorizeMentorToken = (token, channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ token, channelid });

  try {
    const res = await axios.post("/api/mentor/verify", body, config);

    dispatch({
      type: AUTHORIZE_TOKEN,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.msg,
    });
  }
};

// Login Employer
export const loginEmployer = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ email, password });

  try {
    const res = await axios.post("/api/employer", body, config);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: LOGIN_FAIL,
      payload: err.response.data.msg,
    });
  }
};

// Authorize Employer 2FA Token
export const authorizeEmployerToken =
  (token, channelid) => async (dispatch) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ token, channelid });

    try {
      const res = await axios.post("/api/employer/verify", body, config);

      dispatch({
        type: AUTHORIZE_TOKEN,
        payload: res.data,
      });

      dispatch(loadUser());
    } catch (err) {
      const errors = err.response.data.errors;

      if (errors) {
        console.error(errors);
      }

      dispatch({
        type: LOGIN_FAIL,
        payload: err.response.data.msg,
      });
    }
  };

// Delete a user
export const deleteUser = (channelid) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ channelid });

  try {
    const res = await axios.post("/api/owner/delete", body, config);

    dispatch({
      type: DELETE_USER,
      payload: res.data,
    });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: DELETE_USER_ERROR,
    });
  }
};

// Delete User Account
export const deleteAccount = (channelid, password) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const body = JSON.stringify({ channelid, password });

  try {
    const res = await axios.post("/api/owner/delete_account", body, config);

    dispatch({
      type: DELETE_USER_ACCOUNT,
      payload: res.data,
    });
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      console.error(errors);
    }

    dispatch({
      type: DELETE_USER_ACCOUNT_ERROR,
    });
  }
};

// Logout / Clear Profile
export const logout = () => (dispatch) => {
  dispatch({ type: LOGOUT });
  dispatch({ type: CLEAR_PROFILE });
  dispatch({ type: CLEAR_NOTIFICATIONS });
  dispatch({ type: CLEAR_SUBSCRIBERS });
  dispatch({ type: CLEAR_SUBSCRIPTIONS });
  dispatch({ type: CLEAR_BLOCKED_USERS });
  dispatch({ type: CLEAR_GIFTED_SUBSCRIBERS });
  dispatch({ type: CLEAR_EMAIL });
};

// Clear msg
export const clearMsg = () => (dispatch) => {
  dispatch({ type: LOGOUT });
  // dispatch({ type: CLEAR_PROFILE });
  // dispatch({ type: CLEAR_NOTIFICATIONS });
  // dispatch({ type: CLEAR_SUBSCRIBERS });
  // dispatch({ type: CLEAR_SUBSCRIPTIONS });
  // dispatch({ type: CLEAR_BLOCKED_USERS });
  // dispatch({ type: CLEAR_GIFTED_SUBSCRIBERS });
  // dispatch({ type: CLEAR_EMAIL });
};
